import React, { forwardRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import FileUploader from '../../shared/TailwindComponents/FileUploader';
import { fetchDraftTypeFiles, uploadDraftTypeFile } from '../../../store/actions/Drafts/DraftTypesActions';

interface DraftTypeFilesSidePanelProps {
  caseId: string;
  draftTypeName: string;
}

const DraftTypeFilesSidePanel = forwardRef<HTMLDivElement, DraftTypeFilesSidePanelProps>((props, ref) => {
  const { caseId, draftTypeName } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [files, setFiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const fetchedFiles = await dispatch(fetchDraftTypeFiles(caseId, draftTypeName));
        setFiles(fetchedFiles || []);
      } catch (error) {
        console.error('Failed to fetch draft type files:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFiles();
  }, [caseId, draftTypeName, dispatch]);

  const handleUpload = async (newFiles: File[]) => {
    try {
      for (const file of newFiles) {
        await dispatch(uploadDraftTypeFile(caseId, draftTypeName, file));
      }
      const updatedFiles = await dispatch(fetchDraftTypeFiles(caseId, draftTypeName));
      setFiles(updatedFiles || []);
    } catch (error) {
      console.error('Failed to upload files:', error);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white dark:bg-gray-800">
      <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-xl font-medium">{t('Draft type files')}</h2>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {loading ? (
          <p>{t('Loading...')}</p>
        ) : files.length > 0 ? (
          <div className='mb-3'>
            <h3 className="text-lg font-medium mb-2">{t('Uploaded files')}</h3>
            <ul className="space-y-2">
              {files.map((file, index) => (
                <li key={index} className="flex items-center justify-between p-2 bg-gray-100 dark:bg-gray-700 rounded">
                  <span>{file.FileName}</span>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <p>{t('No files uploaded yet.')}</p>
        )}
        <FileUploader files={[]} onFilesChange={handleUpload} />
      </div>
    </div>
  );
});

export default DraftTypeFilesSidePanel;
